import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import NewsletterSubscriptionForm from '../../../components/Forms/Websites/NewsletterSubscription/NewsletterSubscriptionForm';

const NewsletterSubscription = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() =>
        request.getAll('newsletterSubscription')
    );

    const columns = [
        // {
        //     name: 'Name',
        //     center: true,
        //     selector: (row) => row?.name,
        // },
        // {
        //     name: 'Phone',
        //     center: true,
        //     selector: (row) => row?.phone,
        // },
        {
            name: 'Email',
            center: true,
            selector: (row) => row?.email,
        },
        {
            name: 'Status',
            center: true,
            selector: (row) => (row?.status === 1 ? 'Active' : 'Inactive'),
        },
        {
            name: 'Active',
            center: true,
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // const columns = [
    //     {
    //         name: 'Name',
    //         center: 'true',
    //         selector: (row) => row?.name,
    //     },
    //     {
    //         name: 'btn_name',
    //         wrap: true,
    //         center: 'true',
    //         selector: (row) => row?.btn_name,
    //     },
    //     {
    //         name: 'btn_link',
    //         wrap: true,
    //         center: 'true',
    //         selector: (row) => row?.btn_link,
    //     },
    //     {
    //         name: 'Status',
    //         center: 'true',
    //         selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
    //     },
    //     {
    //         name: 'Active',
    //         center: 'true',
    //         cell: (row) => (
    //             <div>
    //                 <EditButton
    //                     onClick={() => {
    //                         setModalOpen('update');
    //                         setSelectedItem(row);
    //                     }}
    //                 />
    //                 <DeleteButton
    //                     onClick={() => {
    //                         setModalOpen('delete');
    //                         setSelectedItem(row);
    //                     }}
    //                 />
    //             </div>
    //         ),
    //     },
    // ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);

        request.create('newsletterSubscription', formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);

        request.updateOne('newsletterSubscription', selectedItem?.id, formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('newsletterSubscription', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Newsletter Subscribers List'
            buttonTitle='Add New'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Welcome Messages'
                    size='lg'
                >
                    <NewsletterSubscriptionForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Welcome Messages'
                    size='lg'
                >
                    <NewsletterSubscriptionForm apiHandler={updateServiceHandler} editData={selectedItem} />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default NewsletterSubscription;
